// Constants
import { protocols } from "../../../../config/constants";

export const RenderProtocolData = (protocolId, t, setProtocolTitle) => {
  switch (Number(protocolId)) {
    // Clinic & Home
    case protocols.clinicAndHome.TOWERS.id:
      setProtocolTitle(t("uppercaseProtocols.towers"));
      break;
    case protocols.clinicAndHome.BALLOONS.id:
      setProtocolTitle(t("uppercaseProtocols.balloons"));
      break;
    case protocols.clinicAndHome.CALIBRATION.id:
      setProtocolTitle(t("uppercaseProtocols.calibration"));
      break;
    case protocols.clinicAndHome.RUNNER.id:
      setProtocolTitle(t("uppercaseProtocols.runner"));
      break;
    case protocols.clinicAndHome.DATA_COLLECTION.id:
      setProtocolTitle(t("uppercaseProtocols.dataCollection"));
      break;
    case protocols.clinicAndHome.PRACTICE.id:
      setProtocolTitle(t("uppercaseProtocols.practice"));
      break;
    default:
      break;
  }
};
